import React, { Component } from 'react';
import PageHeading from '../../components/PageHeading';
import { Alert } from 'reactstrap';
import OrdersService, { ordersService } from '../../services/Orders';
import { Subscribe } from 'unstated';
import { LazyPage } from '../../components/LazyPage';
import ProductList from '../../components/ProductList';

export default class ProductsPage extends Component {
  onAddClick() {
    ordersService.selectProduct({});
  }

  onCancelClick() {
    ordersService.reset();
  }

  render() {
    return (
      <LazyPage>
        <Subscribe to={[OrdersService]}>
          {() => (
            <>
              <Alert hidden={!ordersService.state.isSelectingProducts} color="success" fade={false}>
                Выберите один или несколько товаров и нажмите "Готово" в боковом меню или
                {' '}
                <a role="button" tabIndex="0" onClick={this.onCancelClick}>отмените заказ</a>.
              </Alert>
            </>
          )}
        </Subscribe>

        <PageHeading>Штаны</PageHeading>

        <ProductList/>
      </LazyPage>
    );
  }
}
